import React, { useMemo } from 'react'
import {
  TopNavCurrentPage,
  TopNavRightSide,
  TopNavStyled,
  IconWrapper,
  IconsRow,
  VerticalSeparator,
} from './TopNav.styled'
import { UserMenu } from 'Components/Elements/UserMenu/UserMenu'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChartMixed, faQuestionCircle } from '@fortawesome/pro-light-svg-icons'
import { getPlatformTitleName, getRouteName } from 'Utils/routes'
import { AccountSelector } from '../../../features/AccountSelector/AccountSelector'
import {
  StyledHeader,
  StyledText,
  Tooltip,
  theme,
  useFrontEndEventTrackingService,
} from '@clickcease/cc-client-components-lib'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useGetAccountFeatures } from 'Features/userProfile/api/getAccountFeatures'
import { UserMenuTrigger } from '../UserMenu/UserMenu.styled'
import { useAppStore } from 'Stores/appStoreModuleFed'
import { GLOBAL_MODALS } from 'Types/GlobalModal'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

export const TopNav = () => {
  const { t } = useTranslation('general')
  const navigate = useNavigate()
  const { data } = useGetAccountFeatures()
  const gaConnectorEnabled = data.GA4
  const path = window.location.pathname.replace('/', '')
  const goToGoogleAnalyticsConnector = () => {
    navigate('/google-analytics-connector')
  }
  const { setModalToShow } = useAppStore()
  const { track } = useFrontEndEventTrackingService()

  const pageName = useMemo(() => {
    return getRouteName(path)
  }, [path])

  const platformName = useMemo(() => {
    return getPlatformTitleName(path)
  }, [path])

  return (
    <TopNavStyled>
      <TopNavCurrentPage>
        {!!platformName && (
          <>
            <StyledHeader variant={'h5'}> {platformName}</StyledHeader>
            <VerticalSeparator />
          </>
        )}
        <StyledHeader variant={'h3'}>{pageName}</StyledHeader>
      </TopNavCurrentPage>
      <TopNavRightSide>
        <IconsRow>
          <UserMenuTrigger
            onClick={() => {
              setModalToShow(GLOBAL_MODALS.HELP_CENTER)
              track(['segment'], `Clicked Help Center`, {})
            }}
            style={{ gap: theme.space['5'].value }}
          >
            <IconWrapper>
              <FontAwesomeIcon icon={faQuestionCircle as IconProp} />
            </IconWrapper>
            <StyledText variant={'baseLight'}>{t('top_nav.help')}</StyledText>
          </UserMenuTrigger>
          {gaConnectorEnabled && (
            <IconWrapper tabIndex={0} onClick={goToGoogleAnalyticsConnector}>
              <Tooltip tooltiptContent={t('top_nav.google_analytics_connector_tooltip')}>
                <FontAwesomeIcon icon={faChartMixed as IconProp} />
              </Tooltip>
            </IconWrapper>
          )}
        </IconsRow>
        <AccountSelector />
        <UserMenu />
      </TopNavRightSide>
    </TopNavStyled>
  )
}
